import { wms_url, europe_extent } from './config.js';
import ImageWMS from 'ol/source/ImageWMS'; 
import Image from 'ol/layer/Image';

const createWMSSample = layerName => {
	return new Image({
		extent: europe_extent,
		source : new ImageWMS({
			url : wms_url,
			params : {'LAYERS': layerName}			
		})
	});
}


export default createWMSSample;